import React from "react";
import { Container, Row, Col } from "react-grid-system";
import { Link } from "react-router-dom";

// COMPONENTS
import Title from "../../components/title/title.component";
import { lighten } from "polished";

// SHARED
import { Section } from "../../shared/shared";

// STYLES
import styled from "styled-components";
import Colors from "../../shared/colors";

export default class Inscription extends React.Component {
  render() {
    const { t, i18n } = this.props;
    // TO DO
    return (
      <Section className="backgroundColor">
        <Container>
          <Row>
            <Col sm={12}>
              <Title text={t("Boletim de Inscrição")} />
            </Col>
            <Col sm={12}>
              <Text>{t("Form_in_frase1")}</Text>
            </Col>
            <Col sm={12}>
              <Text>{t("Form_in_frase2")}</Text>
            </Col>
            <CenterButton>
              {i18n.language === "pt" && (
                <Link to="/pt/rede/candidatura">
                  <LinkButton>{t("Boletim de Inscrição")}</LinkButton>
                </Link>
              )}
              {i18n.language === "en" && (
                <Link to="/en/network/apply">
                  <LinkButton>{t("Boletim de Inscrição")}</LinkButton>
                </Link>
              )}

              {i18n.language === "de" && (
                <Link to="/de/netzwerk/anwendung">
                  <LinkButton>{t("Boletim de Inscrição")}</LinkButton>
                </Link>
              )}
            </CenterButton>
          </Row>
        </Container>
      </Section>
    );
  }
}

const Text = styled.p`
  opacity: 0.8;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-family: "PT Sans";
  font-size: 16px;
  margin-top: 5px;
  text-align: center;

  :nth-child(1) {
    margin-bottom: 20px;
  }
`;
const CenterButton = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  margin-bottom: 40px;
`;

const LinkButton = styled.div`
  background-color: ${Colors.primary};
  color: ${Colors.white};
  border-radius: 3px;
  padding: 15px 20px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  font-family: "PT Sans";

  &:hover {
    background: ${lighten(0.05, Colors.primary)};
  }
`;



// WEBPACK FOOTER //
// ./src/components/inscription/inscription.component.js